import styled from "styled-components";
import { colors } from "../../../styles/colors";
import { StyledTitle } from "../../../styles/StyledComponents";

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #536275;
  color: white;
  margin-top: -50px;
  height: 100%;
  padding-bottom: 50px;
  width: 300px;
  position: relative;
  z-index: 405;
  @media only screen and (max-width: 900px) {
    margin: 0px;
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 478px) {
  }
`;

export const ETAPFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #536275;
  color: white;
  margin-top: -50px;
  height: auto;
  padding-bottom: 50px;
  width: 300px;
  position: relative;
  z-index: 405;
  @media only screen and (max-width: 900px) {
    margin: 0px;
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 478px) {
  }
`;

export const FiltersWrapper = styled.div`
  margin: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FiltersTitle = styled(StyledTitle)`
  color: ${colors.white};
  font-family: "Lato";
  font-size: 22px;
  margin-top: 20px;
  margin-left: 20px;
`;
